//@ts-nocheck

import { useCallback } from 'react';

export const useScrollIntoView = () => {
  //Scroll to element
  const scrollTo = useCallback(
    (element, position = 'top', behavior = 'smooth') => {
      if (!element) return;

      let block;
      switch (position) {
        case 'center':
          block = 'center';
          break;
        case 'bottom':
          block = 'end';
          break;
        case 'top':
        default:
          block = 'start';
      }

      element.scrollIntoView({
        behavior,
        block,
        inline: 'nearest'
      });
    },
    []
  );

  //Check if element is in viewport
  const isInViewport = useCallback((element) => {
    if (!element) return false;
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }, []);

  return { scrollTo, isInViewport };
};
